import { collection, getDocs, getFirestore, limit, orderBy, query } from 'firebase/firestore';
import React, { useState, useRef, useEffect } from 'react';
import { Pressable, 
  Text, 
  View, 
  Animated, 
  StyleSheet, 
  TextInput, 
  ScrollView, 
  TouchableOpacity, 
  ImageBackground, 
  ImageSourcePropType,
  ActivityIndicator, 
  } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import { Provider as PaperProvider, Portal, TextInput as PaperTextInput, Modal, IconButton, } from 'react-native-paper';
import { DEBUG, enablePromise, openDatabase } from 'react-native-sqlite-storage';
import { branch, companyDir } from './StockAwareTempData';

 const darkColour='#2a2d3e'
 
interface ChildViewData {
    texts: string[];
  }
  
  
interface MyButtonProps {
    btnText: string;
    btnColor?: string;
    btnWidth?: number;
    btnHeight?: number;
    btnBorWdt?:number;
    btnBorClr?:string;
    btnTxtClr?:string;
    btnFontSize?:number;
    btnBorRadius?:number;
    btnPadding?:number;
    disabled?:boolean;
    hndClicked?:()=> void;
  }

  
interface TextInputProps {
  plhrTxt: string;
  lTxt:string
  scTxt?:boolean
  lbWidth?:number
  cnWidth?:number
  txtWidth?:number
  lbClr?:string
  value?: string
  defaultValue?: string;
  onNoError?: string;
  onBlurError?: string;
  errorMessage?: string;
  showError?: boolean;
  showErrorName?: boolean;
  passwordToCompare?: string;
  optionalError?: boolean;
  refObject?:  React.RefObject<TextInput>;
  makeDigits?: boolean;
  enterKeyIsSunmit?: boolean;
  editable?: boolean; // Makes the textinput uneditable if false. Default value is true
  blurHandled?: boolean;
  blurHandledFunction?: ()=> void;
  onSubmit?: () => void;
  focusReceived?: () => void;
  onChangeText?: (text: string) => void;
  onChange?: (text: string) => void;
  }

export const MyButton: React.FC<MyButtonProps> = ({
btnText= "Login", 
btnColor = '#2a2d3e', 
btnWidth=200, 
btnHeight=40,
btnBorWdt=0,
btnBorClr='#2a2d3e',
btnTxtClr='white',
btnFontSize=17,
btnBorRadius=10,
btnPadding=9,
disabled=false,
hndClicked, 

})=> { 
  const styles = StyleSheet.create( {
    button: {
      backgroundColor: btnColor ,
      padding:btnPadding,
      borderRadius: btnBorRadius,
      width:btnWidth,
      height:btnHeight,
      borderWidth: btnBorWdt,
      borderColor: btnBorClr,
    },
  
    btn:{
      backgroundColor: btnColor,
      borderRadius: btnBorRadius,
      width:btnWidth,
      height:btnHeight,
    },
    buttonHovered: {
      opacity: 0.7,
     
    },
    buttonPressed: {
     opacity:0.5,
      
    },
    buttonText: {
      color: btnTxtClr,
      fontSize: btnFontSize,
      fontFamily:'century gothic',
      textAlign:'center',
      fontWeight:'normal',
    },
  });
  
  
  
  const scaleAnim = useRef(new Animated.Value(1)).current;
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const handleHoverIn = () => {
    setIsHovered(true);
    
  };

  const handleHoverOut = () => {
    setIsHovered(false);
   
  };

  const handlPressedIn = () => {
    setIsPressed(true);
    Animated.timing(scaleAnim, {
      toValue: 0.8,
      duration: 150,
      useNativeDriver: true,
    }).start();
    
  };

  const handlePressedOut = () => {
    setIsPressed(false);
    Animated.timing(scaleAnim, {
      toValue: 1,
      duration: 150,
      useNativeDriver: true,
    }).start();
  };

  return (
  <Animated.View 
    style={[{transform: [{ scale: scaleAnim }]}, 
        styles.btn, 
        isHovered ? styles.buttonHovered : null, 
        isPressed ? styles.buttonPressed : null,
    ]}>
    <Pressable
      style={() => [
        styles.button,
       
      
      ]}
      onPress={hndClicked}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      onPressIn={handlPressedIn}
      onPressOut={handlePressedOut}
      disabled={disabled}
      >
       
        <Text style={styles.buttonText}>{btnText}</Text>
     
     
    </Pressable>
    
  </Animated.View>
  );
};

  
export const TextInputTemp: React.FC<TextInputProps>=({
  lTxt, 
  plhrTxt, 
  value, 
  defaultValue,
  scTxt=false,
  cnWidth=500,
  lbWidth=150,
  txtWidth=348,
  onNoError = 'black',
  onBlurError = '#C40C0C',
  errorMessage = '',
  lbClr= darkColour,
  showError,
  blurHandled = true,
  passwordToCompare,
  showErrorName,
  optionalError,
  refObject,
  makeDigits = false,
  enterKeyIsSunmit = false,
  editable = true,
  onSubmit,
  blurHandledFunction,
  focusReceived,
  onChangeText,
  onChange
})=>{

  const [error, setError] = useState(false);
  showError = error

  const styles = StyleSheet.create ({
    
    parent: {
      margin:10, 
      borderColor: errorMessage && (showError === true || showErrorName === true || optionalError === true)
      ? (errorMessage === 'Phone number may be incorrect' 
      ? '#FF9700' : onBlurError) : onNoError, 
      backgroundColor: 'white', 
      width:cnWidth, 
      height:40, 
      borderRadius:10, 
      alignItems:'center', 
      alignSelf:'center', 
      flexDirection:'row', 
      borderWidth: 1
    },
    parentText: {
      color: errorMessage && (showError === true || showErrorName === true || optionalError === true)
      ? (errorMessage === 'Phone number may be incorrect' 
      ? '#FF9700' : onBlurError) : 'white', 
      fontFamily:'century gothic', 
      fontSize:16, 
      padding:10, paddingHorizontal:5, 
      fontWeight:'normal', 
      alignSelf:'center', 
      verticalAlign:'middle'
    }

  })

  const [textValue, setTextValue] = useState('')
  const isAlphanumeric = (value: string) => {
  const hasLetter = /[a-zA-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  return hasLetter && hasNumber;
  };

  const handleBlur = () => {
    if  (errorMessage === "Password must be at least 8 characters, and alphanumeric" && value && value?.length < 8) {
      setError(true)
    } else if (errorMessage === "Password must be at least 8 characters, and alphanumeric" && value && (!isAlphanumeric(value)) ) {
      setError(true)
    } else if  (errorMessage === "Password mismatch" && value && passwordToCompare && value !== passwordToCompare ) {
      setError(true)
    } else if (errorMessage === 'Phone number may be incorrect' && value && value.length < 11) {
      setError(true)
    } else setError(false)
  };

  const handleFocus = () => {
    if (focusReceived) {
       focusReceived()
    }
   
    setError(false)
    errorMessage = ''
    };

    const changeText = (text: string) => {
      if (onChangeText){
        onChangeText(text)
      }
      if (makeDigits === true) {
        const digitsOnly = text.replace(/[^0-9]/g, '');
        setTextValue(digitsOnly)
      }
    }

    const onChangeT = (text: string) => {
      if (onChange){
        onChange(text)
      }
      if (makeDigits === true) {
        const digitsOnly = text.replace(/[^0-9]/g, '');
        setTextValue(digitsOnly)
      }
    }

    return(
     <View style={{...styles.parent}}>
      <View style={{width:lbWidth, height: '100%', borderTopLeftRadius:10, borderBottomLeftRadius: 10, backgroundColor:lbClr}}>
       <Text style={{...styles.parentText}}>
          {lTxt}
       </Text>
      </View>
      <View style={{height: '100%'}}>
          <TextInput
          style={{borderRadius:10, 
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderWidth: 0,
            borderColor: 'white',
            height:30, 
            width:txtWidth, 
            fontSize: 17,
            backgroundColor:'white',
            padding:8,
            paddingBottom:2,
            flexGrow:1,
            //elevation:4           
          }}
          ref={refObject}
          value = {makeDigits ? textValue : value}
          defaultValue = {defaultValue}
          editable = {editable}
          placeholder= {plhrTxt}
          secureTextEntry= {scTxt}
          onFocus={handleFocus}
          onBlur={()=>{blurHandled? handleBlur() : handleBlur(); blurHandledFunction? blurHandledFunction() : {}}}
          onChangeText={changeText}
          onChange={(value)=> onChangeT(value.nativeEvent.text)}
          spellCheck={false}
          onSubmitEditing={() => enterKeyIsSunmit ? onSubmit ? onSubmit() : null : null}
        />
        {(showError === true || showErrorName === true || optionalError === true) && errorMessage &&  (
        <Text style={{ color: (errorMessage === 'Phone number may be incorrect' 
        ? '#FF9700' : onBlurError), marginTop: -6, fontSize:12 }}>{errorMessage}</Text>
        )}
      </View>
      
      </View>
    )
  }

  interface ChildViewData {
    id: string;
    texts: string[];
  }

  interface SalesList {
    id: string;
    salesId: string;
    quantity: number;
    board: string;
    customer: string;
    paymentMethod: string;
    date: string;
    delivered: string;
    notes: string;
    itemPrice: number;
    total: number;
    discount: number;
    afterDiscount: number;
  };
  
const ChildView = ({texts, index}: ChildViewData & {index: number}) => {
  const isEvenIndex = index % 2 === 0;
  const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
  const sizes: number[] = [57, 331, 102, 152];
return (
  <View style={{ backgroundColor}}>
    <TouchableOpacity
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'transparent',
        height:35,
        borderColor:'black',
        borderTopWidth:2,
        borderBottomWidth:2,
        marginTop:-2,
        
      }}
     
    >
     
      {texts.map((text, i) => (
      
      <View  
      key={i} 
      style={{
        
          width:(sizes[i]), 
          borderWidth:2, 
          borderColor:'black', 
          height:'100%', 
          alignItems:'center', 
          marginLeft:-2, 
          borderTopWidth:0, 
          borderBottomWidth:0
          }}>
          <Text 
          key={i} 
          style={{
              color: darkColour,
              fontFamily:'century gothic', 
              fontSize:15, 
              fontWeight:'normal',
              marginTop:6
              }}>
                  {text}
          </Text>
      </View>
        
      ))}
    </TouchableOpacity>
  </View>
);
};
  
export const DataGridView = ()=>{

  const salesArray: SalesList[] = [];
  const [sales, setSales] = useState<SalesList[]>([]);
  const [filteredResult, setFilteredResult] = useState<SalesList[]>([]);
  const [checkedItems, setCheckedItems] = useState<boolean[]>([]);
  const [totalRows, setTotalRows] = useState(-1);
  const [searchText, setSearchText] = useState('');
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
  const [clear, setClear] = useState(true)
	const [clearCheck, setClearCheck] = useState(false)
  let timeout: NodeJS.Timeout

  const fetchStocks = async () => {
    const salesColRef = collection(getFirestore(), companyDir, branch, 'salesItems');
    const salesRows: SalesList[] = [];

    (async () => {

      const salesQuery = query(salesColRef, orderBy('date', 'desc'), limit(30));
      const salesSnapshot = await getDocs(salesQuery)

      setTotalRows(salesSnapshot.size)

      for (const salesDoc of salesSnapshot.docs) {
        const salesData = salesDoc.data()

        const stockArrayCol = {
          id: salesDoc.id,
          ...salesData
        }

        salesRows.push(stockArrayCol as unknown as SalesList)
      }

      setSales(salesRows);
      setFilteredResult(salesRows);

      const updatedCheckedItems: boolean[] = Array.from(
        { length: salesRows.length },
        () => false
      );
      setCheckedItems(updatedCheckedItems)

    })()
  }

  useEffect(() => {
    setTimeout(() => {
      setClear(false)
      setClearCheck(true)
    }, 5000);
  }, []);

  useEffect(() => {
    if (!clear) {
        fetchStocks()
    }
  
  }, [clearCheck]);

  useEffect(() => {
    if (!clear) {
    timeout = setTimeout(() => {
      if (totalRows !== -1 && filteredResult.length === totalRows) {
        setShowLoadingIndicator(true)
      }
    }, 10000);
    if (totalRows !== -1 && filteredResult.length === totalRows) {
      clearTimeout(timeout)
      setTimeout(() => {
          setShowLoadingIndicator(false)
      }, 200);
    
    }
  }
  }, [totalRows, filteredResult, clearCheck]);

  useEffect(() => {
    if (!clear) {
    const filterChildViews = async () => {
      const filteredViews = await filterViews() as SalesList[];
      setFilteredResult(filteredViews);
    };
    filterChildViews();
  }
  }, [sales, checkedItems, searchText, clearCheck]);

  const handleSearchTextChange = (value: string) => {
    setSearchText(value);
  };

  const filterViews = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const filteredViews = sales.filter((child) => {
          const hasTextMatch = ((child.board ? child.board.toLowerCase() : '') + (child.paymentMethod 
            ? child.paymentMethod.toLowerCase() : '') + (child.customer 
              ? child.customer.toLowerCase() : '') + (child.notes 
                ? child.notes.toLowerCase() : '')).includes(searchText.toLowerCase())
          const hasIdMatch = child.id.toString().includes(searchText.toLowerCase());
          return hasTextMatch || hasIdMatch;
        });

        resolve(filteredViews);
      }, 0);
    });
  };

  return(
    <View style={{...stylesBox.smallBox, height:438, width:626}}>
      <View style={{flexDirection:'row', height:70, width:626, alignItems:'center'}}>
        <Text style={{...stylesBox.mediumText, fontSize:20, color:darkColour, marginTop:0, flex:1}}>
          Recent Sales
        </Text>
        <View style={{flexDirection:'column', flex:2}}>
          <View style={{width:350}}>
            <PaperTextInput
              mode="outlined"
              label={'Search record'}
              placeholder="Search"
              underlineColor={darkColour}
              activeOutlineColor={darkColour}
              spellCheck={false}
              contentStyle={{
                paddingTop: 7, 
                borderWidth:1, 
                width: 350, 
                height:40, 
                borderRadius:10, 
                borderColor: '#DCE3E8'
              }} 
              outlineStyle={{ borderWidth: 0, height:40 }}
              onChangeText={handleSearchTextChange}
            /></View>
        </View>
      </View>
            
      <View style={{width:'100%', height:35, backgroundColor: darkColour, flexDirection:'row'}}>
          <View style={{...stylesBox.columnHeaderBox, marginLeft: 0, borderLeftWidth: 0}}>
            <Text style={{...stylesBox.columnHeaderText}}>
              Qty
            </Text>
          </View>
          <View style={{...stylesBox.columnHeaderBox, width:331}}>
            <Text style={{...stylesBox.columnHeaderText}}>
              Board Description
            </Text>
          </View>
          <View style={{...stylesBox.columnHeaderBox, width:100}}>
            <Text style={{...stylesBox.columnHeaderText}}>
              Amount (₦)
            </Text>
          </View>
          <View style={{...stylesBox.columnHeaderBox, width:144, borderRightWidth: 0}}>
            <Text style={{...stylesBox.columnHeaderText}}>
              Total Amount (₦)
            </Text>
          </View>
      </View>
            
      {showLoadingIndicator  ? (
        <ActivityIndicator size="large" color= {darkColour} style ={{ marginTop: 120}} />
        ) : ( 
          <ScrollView>
          {filteredResult.map((item, index) => (
            <ChildView
              key={item.id}
              texts={[
                item.quantity ? item.quantity.toString() : '0',
                item.board,
                item.itemPrice ? Number(item.itemPrice).toLocaleString('en-NG') : '0.00',
                item.total ? Number(item.total).toLocaleString('en-NG') : '0.00',
              ]}
              index={index}
              id={item.id}
            />
          ))}
        </ScrollView>
      )}

    </View>
  
  )
}

const stylesBox = StyleSheet.create ({
  smallBox: {
    width: 190, 
    height:120, 
    backgroundColor:'white', 
    borderRadius:10,
    borderColor:'#DCE3E8',
    alignContent:'center',
  },
  smallText: {
    color:'#616161', 
    fontFamily:'century gothic', 
    fontSize:12, 
    fontWeight:'300', 
    textAlign:'center',
    
  },

  bigText: {
    color:'#2A6AA7', 
    fontFamily:'century gothic', 
    fontSize:30, 
    fontWeight:'normal', 
    textAlign:'center',
    
  },

  mediumText: {
    color:'grey', 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    },
  
  columnHeaderBox: {
    borderWidth:2, 
    borderColor:'black', 
    width:57,  
    height:'100%', 
    alignItems:'center',
    marginLeft:-2,
    borderTopWidth:2, 
    borderBottomWidth:0
  },

    columnHeaderText: {
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    color:'white', 
    marginTop:6
    }

})
  
interface AvartaProps {
  source: ImageSourcePropType;
  onImageSelected: (imageString: string) => void;
}
export const AvartaDropDown: React.FC<AvartaProps> = ({source, onImageSelected}) => {
  interface avatarProps{
    indexCheck : number;
    avatarLocation: ImageSourcePropType;
    avartaPath: string
  }
  const [visible, setVisible] = React.useState(false);
  const showAvMenu=()=>{
    visible ? slideOpen() : slideClose()
    setVisible((prevState) => !prevState);
  }
  
 
  const containerStyle = {backgroundColor: 'white', marginTop:-440, width:250, height:300, borderRadius:10, borderWidth:1};
  const scaleAnim = useRef([...Array(18)].map(() => new Animated.Value(1))).current;
  const [backgroundImage, setBackgroundImage] = useState(source);
  const animation = useRef(new Animated.Value(1)).current;

    const slideOpen = () => {
      Animated.timing(animation, {
        toValue: 0,
        duration: 150,
        useNativeDriver: true,
      }).start()
   }
   const slideClose = () => {
      Animated.timing(animation, {
        toValue: 1,
        duration: 300,
        useNativeDriver: true,
      }).start()
   }
  
  const handleHoverIn = (ind:number) => {
   
    Animated.timing(scaleAnim[ind], {
      useNativeDriver: true,
      toValue: 1.2,
      duration: 100,
    }).start();
 };

  const handleHoverOut = (ind:number) => {
  
      Animated.timing(scaleAnim[ind], {
        useNativeDriver: true,
        toValue: 1,
        duration: 100,
          }).start();
  };

  const handlPressedIn = (imgSource: ImageSourcePropType, ind:number, avartaPath: string) => {
    setVisible(false);
    setBackgroundImage(imgSource);
    handleHoverOut(ind)
    onImageSelected(avartaPath);
  };

  const RenderAvatar: React.FC<avatarProps> = ({indexCheck, avatarLocation, avartaPath}) =>{

    return( 
      <View style={{width:80, height:80, padding:10}}>
      <Animated.View 
      style={[{transform: [{ scale: scaleAnim[indexCheck]}]}, 
          styles.btn, 
          
      ]}>
      <Pressable
        style={() => [
          styles.button,
          
        ]}
        onHoverIn={() =>{handleHoverIn(indexCheck)}}
        onHoverOut={() =>{handleHoverOut(indexCheck)}}
        onPress={() =>{handlPressedIn(avatarLocation, indexCheck, avartaPath)}}
       
        > 
         <ImageBackground
            source={avatarLocation}
            style={{ flex: 1, }}
            resizeMode='cover' 
            imageStyle={{opacity:1}}
          />   
       </Pressable>
      </Animated.View>
      </View>
    )
  }

  const AvatarMenu=()=>{

    return(
      <View style={{width:250, height:300}}>
        <View>
          <TouchableOpacity onPress={showAvMenu} style={{height:30, backgroundColor:'#2a2d3e'}}>
            <Text style={styles.buttonText}>
              Close
            </Text>
          </TouchableOpacity>
        </View>

        <ScrollView 
          style={[styles.scene, 
          { backgroundColor: 'white', 
          flexDirection:'column', 
          width: 250, 
          height: 300 }]}
        >
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={0} avatarLocation={require('./src_Files/Avatars/1-black-shade-girl.png')} avartaPath='./src_Files/Avatars/1-black-shade-girl.png' />
            <RenderAvatar indexCheck={1} avatarLocation={require('./src_Files/Avatars/2-blue-eyes-male.png')} avartaPath='./src_Files/Avatars/2-blue-eyes-male.png' />
            <RenderAvatar indexCheck={2} avatarLocation={require('./src_Files/Avatars/3-boy-on-hood.png')} avartaPath='./src_Files/Avatars/3-boy-on-hood.png' />
          </View>
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={3} avatarLocation={require('./src_Files/Avatars/4-eye-glass-male.png')} avartaPath='./src_Files/Avatars/4-eye-glass-male.png' />
            <RenderAvatar indexCheck={4} avatarLocation={require('./src_Files/Avatars/5-faceless-black-girl.png')} avartaPath='./src_Files/Avatars/5-faceless-black-girl.png' />
            <RenderAvatar indexCheck={5} avatarLocation={require('./src_Files/Avatars/6-faceless-black-hair.png')} avartaPath='./src_Files/Avatars/6-faceless-black-hair.png' />
          </View>
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={6} avatarLocation={require('./src_Files/Avatars/7-faceless-black-lady.png')} avartaPath='./src_Files/Avatars/7-faceless-black-lady.png' />
            <RenderAvatar indexCheck={7} avatarLocation={require('./src_Files/Avatars/8-faceless-female.gif')} avartaPath='./src_Files/Avatars/8-faceless-female.gif' />
            <RenderAvatar indexCheck={8} avatarLocation={require('./src_Files/Avatars/9-faceless-girl.png')} avartaPath='./src_Files/Avatars/9-faceless-girl.png' />
          </View>
        
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={9} avatarLocation={require('./src_Files/Avatars/10-faceless-g-laughing.png')} avartaPath='./src_Files/Avatars/10-faceless-g-laughing.png' />
            <RenderAvatar indexCheck={10} avatarLocation={require('./src_Files/Avatars/11-faceless-lady.png')} avartaPath='./src_Files/Avatars/11-faceless-lady.png' />
            <RenderAvatar indexCheck={11} avatarLocation={require('./src_Files/Avatars/12-faceless-male.gif')} avartaPath='./src_Files/Avatars/12-faceless-male.gif' />
          </View>
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={12} avatarLocation={require('./src_Files/Avatars/13-fam-guy-Brian.png')} avartaPath='./src_Files/Avatars/13-fam-guy-Brian.png' />
            <RenderAvatar indexCheck={13} avatarLocation={require('./src_Files/Avatars/14-man-laughing.png')} avartaPath='./src_Files/Avatars/14-man-laughing.png' />
            <RenderAvatar indexCheck={14} avatarLocation={require('./src_Files/Avatars/15-office-man.png')} avartaPath='./src_Files/Avatars/15-office-man.png' />
          </View>
          <View style={{flexDirection:'row'}}>
            <RenderAvatar indexCheck={15} avatarLocation={require('./src_Files/Avatars/16-young-boy.png')} avartaPath='./src_Files/Avatars/16-young-boy.png' />
            <RenderAvatar indexCheck={16} avatarLocation={require('./src_Files/Avatars/17-young-girl.png')} avartaPath='./src_Files/Avatars/17-young-girl.png' />
            <RenderAvatar indexCheck={17} avatarLocation={require('./src_Files/Avatars/18-young-white-boy.png')} avartaPath='./src_Files/Avatars/18-young-white-boy.png' />
          </View>
        </ScrollView>
      </View>
    );
  };

  return(
    <View >
      <PaperProvider>
        <Portal>
          <TouchableOpacity style={{width:70, height:70, backgroundColor:'white', borderRadius:50, borderWidth:1, borderColor:'#2a2d3e'}} onPress={showAvMenu}>
          <ImageBackground
            source={backgroundImage}
            style={{ flex: 1, }}
            resizeMode='cover' 
            imageStyle={{opacity:1}}
          />   
          </TouchableOpacity>
          <Animated.View style={[{ transform: [{ translateY: animation.interpolate({ inputRange: [0, 1], outputRange: [70, 0] }) }] }]}>
            <Modal visible={visible} contentContainerStyle={containerStyle} >
              <AvatarMenu/>
            </Modal>
          </Animated.View>   
        </Portal>
      </PaperProvider>
    </View>
  );
};

interface SelectGender {
  gender?: string;
  disabled: boolean
  onError?: boolean;
  pressed?: ()=> void;
  onGenderSelected: (gender: string) => void;
}

export const GenderSelect: React.FC<SelectGender> = ({gender, disabled, onError=false, pressed, onGenderSelected}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [items, setItems] = useState([
    {label: 'Male', value: 'Male', icon: () => <IconButton icon="human-male" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'Female', value: 'Female', icon: () => <IconButton icon="human-female" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}
  ]);
  
  useEffect(() => {
   setValue(gender ? gender : '');
  }, []);

  return (
   <View style={{width:200, height:40}}>
    <DropDownPicker
      disabled = {disabled}
      theme="DARK"
      modalAnimationType='slide'
      placeholder='Gender'
      style={{borderRadius:10, borderWidth:1, height: 40, borderColor:onError ? '#C40C0C' : darkColour}}
      open={open}
      value={value}
      items={items}
      setOpen={setOpen}
      setValue={setValue}
      setItems={setItems}
      onChangeValue={(value) => {
        if (value !== null) {
          onGenderSelected(value);
        }
      }}
      listItemContainerStyle={{backgroundColor:'white'}}
      onPress={pressed}
      listItemLabelStyle={{color:'black', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
      textStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
      placeholderStyle={{color: onError ? '#C40C0C' : 'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300', textAlign:'center'}}
      
    />
   
   </View>
  );
};

const styles = StyleSheet.create({
  scene:{
    flex:1
  },
  button: {
    borderRadius: 60,
    width:70,
    height:70,
   backgroundColor:'transparent'
  },
  btn:{
    borderRadius: 60,
    width:70,
    height:70,
    backgroundColor:'transparent'
  },
  buttonText: {
    marginTop:5,
    fontSize: 15,
    fontFamily:'century gothic',
    textAlign:'center',
    fontWeight:'normal',
    color:'white'
  },
});
 
  
